enum CacheStatus {
    CacheInstalled = 0,
    CacheFailed = 1,
    CacheCleared = 2,
}

export default CacheStatus;
